import { VerificationHomeQueryResults } from '../useVerificationQuery/types';

const getIsYetToSelectPlan = (data: VerificationHomeQueryResults): boolean => {
  const {
    viewer: {
      company: { isCapitalDeposit, isShineStart, metadata, shineStart },
    },
  } = data;
  if (metadata === undefined) {
    // This is the case for non-primary applicant users.
    return false;
  }
  if (isCapitalDeposit) {
    return false;
  }
  if (isShineStart) {
    if (shineStart === null || shineStart === undefined) {
      throw new Error(
        'ShineStart not available on viewer despite isShineStart=true',
      );
    }
    return shineStart.isPaid;
  }
  return metadata.selectedPlanId === null;
};

export default getIsYetToSelectPlan;
